import { render, staticRenderFns } from "./new_patient.vue?vue&type=template&id=e54be234&"
import script from "./new_patient.vue?vue&type=script&lang=js&"
export * from "./new_patient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports